import React from 'react';

const formatDate = (value) => {
  if (!value) return null;
  try { return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(value)); } catch { return value; }
};

export default function SeoTrustBlock({ page }) {
  return (
    <aside className="rounded-card border border-line bg-paper-alt p-5 text-sm text-muted leading-6">
      <p className="font-semibold text-ink mb-1">Conteúdo profissional revisado</p>
      {page.author?.name && <p>{page.author.name}{page.author?.credential ? `, ${page.author.credential}` : ''}</p>}
      <p>Publicado em {formatDate(page.published_at)}{page.reviewed_at ? `. Revisado em ${formatDate(page.reviewed_at)}` : ''}</p>
      {page.professional_notice && <p className="mt-3">{page.professional_notice}</p>}
    </aside>
  );
}
